import { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import routes from "./config";

export function AppRoutes() {
  const element = useRoutes(routes);

  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex items-center justify-center bg-background-50 text-foreground-600">
          Cargando…
        </div>
      }
    >
      {element}
    </Suspense>
  );
}
